<script>
import { useI18n } from "vue-i18n";

import { ElMessageBox } from "element-plus";

export default {
  props: {
    modelValue: String,
    labelKey: String,
    nameKey: String,
    data: [],
  },
  setup(props, { emit }) {
    const { t } = useI18n();

    const onEdit = (value, index) => {
      emit("edit", value, index);
    };
    const onDelete = (value, index) => {
      ElMessageBox.confirm(t("commonMessageBox"), {
        confirmButtonText: t("commonBtnConfirm"),
        cancelButtonText: t("commonBtnCancel"),
        type: "warning",
      }).then(() => {
        emit("delete", value, index);
      });
    };
    const onChange = (val) => {
      // emit("change", val);
      emit("update:modelValue", val);
    };

    return {
      onEdit,
      onDelete,
      onChange,
    };
  },

  render() {
    console.log(this, "1123");
    return (
      <el-tabs type="card" model-value={this.modelValue} onTabChange={this.onChange}>
        {this.data.map((item, index) => {
          const key = this.nameKey ? item[this.nameKey] : index;

          return (
            <el-tab-pane
              key={key}
              name={key}
              v-slots={{
                label: () => {
                  return (
                    <div class="pane-label">
                      <div class="text">{item[this.labelKey]}</div>
                      {this.modelValue === key ? (
                        <div class="control">
                          <div class="icon" onClick={() => this.onEdit(item, index)}>
                            <el-icon>
                              <Edit />
                            </el-icon>
                          </div>
                          {this.$attrs.onDelete ? (
                            <div class="icon" onClick={() => this.onDelete(item, index)}>
                              <el-icon>
                                <Delete />
                              </el-icon>
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  );
                },
              }}
            >
              {this.$slots.default ? this.$slots.default(item, index) : null}
            </el-tab-pane>
          );
        })}
      </el-tabs>
    );
  },
};
</script>
<style lang="scss" scoped>
.el-tabs__nav .el-tabs__item:nth-child(1) .el-icon {
  display: inline-flex;
}
.pane-label {
  display: flex;
  .text {
    margin-right: 20px;
  }
  .control {
    display: flex;
    padding-top: 2px;
    .icon {
      width: 16px;
      height: 16px;
    }
    .del {
      margin-left: 10px;
    }
  }
}
</style>
